import type { FC } from 'react';
import type { Filter } from '../../../../../../../stores/filters';
import CustomUrlParamsFilter from '../../CustomUrlParamFilter';
import type { URLParamFilterConfig } from '../../hooks';

interface ParamsFilterProps {
  onChange: (filter: Filter) => void;
}

const filterConfig: URLParamFilterConfig = {
  param1: {
    label: 'Param 1',
    filterName: 'site_param1_filter',
    field: 'param1_suggestion',
  },
  param2: {
    label: 'Param 2',
    filterName: 'site_param2_filter',
    field: 'param2_suggestion',
  },
  param3: {
    label: 'Param 3',
    filterName: 'site_param3_filter',
    field: 'param3_suggestion',
  },
  param4: {
    label: 'Param 4',
    filterName: 'site_param4_filter',
    field: 'param4_suggestion',
  },
  param5: {
    label: 'Param 5',
    filterName: 'site_param5_filter',
    field: 'param5_suggestion',
  },
  formtext: {
    label: 'Site Formtext',
    filterName: 'site_formtext_filter',
    field: 'formtext_suggestion',
  },
  clicktext: {
    label: 'Site Clicktext',
    filterName: 'site_clicktext_filter',
    field: 'clicktext_suggestion',
  },
};

const ParamsFilter: FC<ParamsFilterProps> = ({ onChange }) => {
  return <CustomUrlParamsFilter onChange={onChange} paramConfig={filterConfig} />;
};

export default ParamsFilter;
